module.exports = __webpack_public_path__ + "media/images/icon_view-4529ba31e3d468132f07fe027fdf4d69.svg";